<template>
  <div class="container mt-5">
    <button
      class="font-medium f12 btn btn-outline-secondary"
      data-toggle="tooltip"
      data-placement="top"
      data-original-title="Xuất Excel"
      @click="zipData"
    >
      <i class="bx bx-download"></i><span>&nbsp;</span>Tải files
    </button>
    <div class="card">
      <p>
        Số lượng thành công trên tổng số file cần tải: {{ fileTaiduoc.length }} /
        {{ datahehe.length }}
      </p>
      <p>
        Số lượng thành công trên tổng số file cần tải: {{ fileKhongTaiDc.length }} /
        {{ datahehe.length }}
      </p>
    </div>
    <div>
      dữ liệu thất bại:
      {{ fileKhongTaiDc }}
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"></VueLoadingOverlay>
  </div>
</template>
<script>
  import JSZip from 'jszip'
  import { saveAs } from 'file-saver'
  import datahehe from '@/pages/gpdkkd/data.json'
  import { GPDKKDService } from '@/services/gpdkkd.service'
  import { MerchantService } from '@/services/merchant.service'
  export default {
    components: {},
    data() {
      return {
        showLoading: false,
        datahehe,
        fileKhongTaiDc: [],
        fileTaiduoc: [],
      }
    },
    methods: {
      async downloadFiles(item) {
        try {
          const resMid = await MerchantService.getMposMid(item.customerId)
          if (resMid.success === false) {
            this.fileKhongTaiDc.push(item)
            return false
          }
          if (item.businessRegistrationWkType === 'SALE') await this.zipFilesSale(resMid.data, item)
          else await this.zipFilesAfs(resMid.data, item)
        } catch (error) {
          this.fileKhongTaiDc.push(item)
          return false
        } finally {
        }
        return true
      },
      async getBlob(url) {
        const blob = await GPDKKDService.getFileFromS3({ url })
        return new Promise(resolve => {
          const splitArr = url.split('/')
          const filename = splitArr[splitArr.length - 1]
          resolve({
            blob,
            filename,
          })
        })
      },
      async zipFilesSale(body, item) {
        try {
          const res = await GPDKKDService.getSale({ id: item.businessRegistrationWkId })
          const hexdata = res.data
          const zip = new JSZip()
          const folderName = `[${body.mid}]_${body.shortName}`
          var img = zip.folder(folderName)
          const resfileXlsx = await MerchantService.exportMposMid(item.customerId)
          img.file('HS cá nhân bổ sung giấy DKKD.xlsx', resfileXlsx.data)
          const urls = await Promise.all(hexdata.urlImage.map(s => this.getBlob(s)))
          urls.forEach(value => img.file(value.filename, value.blob))
          zip
            .generateAsync({
              type: 'blob',
            })
            .then(function (content) {
              saveAs(content, `${folderName}.zip`)
            })
          this.fileTaiduoc.push(item)
        } catch (error) {
          this.fileKhongTaiDc.push(item)
        }
      },
      async zipFilesAfs(body, item) {
        try {
          const res = await GPDKKDService.getAfs({ id: item.businessRegistrationWkId })
          const hexdata = res.data
          const zip = new JSZip()
          const folderName = `[${body.mid}]_${body.shortName}`
          var img = zip.folder(folderName)
          const resfileXlsx = await MerchantService.exportMposMid(item.customerId)
          img.file('HS cá nhân bổ sung giấy DKKD.xlsx', resfileXlsx.data)
          const urls = await Promise.all(hexdata.images.map(s => this.getBlob(s)))
          urls.forEach(value => img.file(value.filename, value.blob))
          const urlsMc = await Promise.all(hexdata.mcUploadImages.map(s => this.getBlob(s)))
          urlsMc.forEach(value => img.file(value.filename, value.blob))
          zip
            .generateAsync({
              type: 'blob',
            })
            .then(function (content) {
              saveAs(content, `${folderName}.zip`)
            })
          this.fileTaiduoc.push(item)
        } catch (error) {
          this.fileKhongTaiDc.push(item)
        }
      },
      // dữ liệu bảng
      async zipData() {
        this.fileKhongTaiDc = []
        this.fileTaiduoc = []
        this.showLoading = true
        try {
          for await (const data of datahehe) {
            await this.downloadFiles(data)
          }
        } catch (error) {
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>
